<template>
  <modal-container v-model="show">
    <template>
      <block-base-form :flexClass="''" :fields="fields" @cancel="show = false" @save="save">
        <template v-slot:prepend>
          <page-title class="pa-5 pb-0">{{ $t("Change Password") }}</page-title>
        </template>
      </block-base-form>
    </template>
  </modal-container>
</template>

<script>
import { $t } from "@/lib/helpers/i18nHelper";
import emitter from "@/lib/helpers/emitter";
import ModalContainer from "@/components/ModalContainer.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";
import PageTitle from "@/components/PageTitle.vue";

export default {
  name: "ModalChangePassword",
  components: { BlockBaseForm, ModalContainer, PageTitle },
  props: {
    userId: { type: String, required: true },
  },
  data() {
    return {
      show: false,
      fields: [
        {
          name: "password",
          title: $t("Enter new password"),
          type: "password",
          value: "",
        },
      ],
    };
  },
  methods: {
    save({ password }) {
      if (!password) return;
      let data = {
        id: this.userId,
        password,
      };
      this.$emit("updateUser", data);
      this.show = false;
    },
    showModalChangePassword() {
      this.show = true;
    },
    hideModalChangePassword() {
      this.show = false;
    },
  },
  created() {
    emitter.on("showModalChangePassword", this.showModalChangePassword);
    emitter.on("hideModalChangePassword", this.hideModalChangePassword);
  },
  beforeDestroy() {
    emitter.off("showModalChangePassword", this.showModalChangePassword);
    emitter.off("hideModalChangePassword", this.hideModalChangePassword);
  },
};
</script>
